import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import LinkLookup from 'components/LinkLookup';
import moment from 'moment';
import React from 'react';
import { EnvelopeAction } from 'types';
import LoadHtmlPlugin from 'utils/lexical/LoadHtmlPlugin';
import { MentionNode } from 'utils/lexical/Mentions/MentionNode';
import MentionsPlugin from 'utils/lexical/Mentions/MentionsPlugin';

type ComponentProps = {
  comment: EnvelopeAction;
};

const CommentListRow: React.FC<ComponentProps> = ({ comment }) => {
  const { value, created_at: createdAt, envelope_uuid: envelopeId, payload } = comment;

  // @ts-ignore
  const isInlineComment = payload?.lineIndex !== undefined;

  const commentConfig: InitialConfigType = {
    namespace: 'comment-editor-row',
    nodes: [MentionNode],
    editable: false,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any): void => {
      throw error;
    },
  };

  return (
    <LinkLookup
      as="tr"
      routeName="envelope-detail"
      routeParams={{ envelopeId }}
      queryParams={{ envelopes__from_comments: 'true' }}
      className="border-t border-litlingo-gray-1 table-row h-10 align-top bg-white hover:bg-litlingo-gray-1"
    >
      <td className="table-wrapper__new-td">
        <div className="flex flex-row items-start gap-1 py-2.5 pl-6 pr-4 text-body">
          <div className="flex overflow-hidden truncate">
            <LexicalComposer initialConfig={commentConfig}>
              <LoadHtmlPlugin edited={false} insertQuotes content={value || ''} />
              <MentionsPlugin initialOptions={[]} />
              <RichTextPlugin
                contentEditable={
                  <ContentEditable
                    aria-placeholder="Hit 'Enter' to save"
                    placeholder=""
                    className=""
                  />
                }
                ErrorBoundary={LexicalErrorBoundary}
              />
            </LexicalComposer>
          </div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="flex py-2.5 pr-4 text-body">
          <div>{isInlineComment ? 'Inline' : 'Document'}</div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="flex flex-row items-start gap-1 py-2.5 pr-4 text-body">
          <div className="flex overflow-hidden">
            <div>{moment(createdAt).format('DD MMM yyyy, hh:mma')}</div>
          </div>
        </div>
      </td>
    </LinkLookup>
  );
};

export default CommentListRow;
